<template>
  <div class="col-md-12 px-6">
    <div style="border:1px solid #D6D5D5; border-radius: 5px;background-color: #F6F6F6" class="px-3 py-5 row">
      <div class="col-md-6 mb-4">
        <p>Mã tác vụ</p>
        <el-input placeholder="-" :value="taskDetail?.id"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Phân loại</p>
        <el-input placeholder="-"
                  :value="taskDetail?.type ? typeTask[taskDetail.type] : '-'"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Buổi học đặt lịch gia sư</p>
        <el-input placeholder="-" :value="taskDetail.lesson"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Nội dung gia sư</p>
        <div style="display: flex; flex-direction: column; gap: 4px; border: 1px solid darkgray; border-radius: 3px">
          <span v-for="(content, index) in taskDetail.content" :key="index">
            {{content}}
          </span>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <p>Ngày làm</p>
        <el-input placeholder="-"
                  :value="formatDate(taskDetail.date)"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Thời gian bắt đầu</p>
        <el-input placeholder="-"
                  :value="taskDetail.start_time ? `${ taskDetail.start_time }:00` : '-'"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Thời gian kết thúc</p>
        <el-input placeholder="-" :value="taskDetail.end_time ? `${ taskDetail.end_time }:00` : '-'"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Trình độ học</p>
        <el-input placeholder="-" :value="taskDetail.level"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Chi nhánh học</p>
        <el-input placeholder="-"
                  :value="taskDetail.center_name"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Họ và tên học viên</p>
        <div style="position: relative">
          <el-input placeholder="-" :value="taskDetail.name"></el-input>
          <button @click="goStudentDetail" style="color: #0066FF; position: absolute; top: 50%; transform: translateY(-50%); right: 8px">Xem chi tiết</button>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <p>Số điện thoại học viên</p>
        <el-input placeholder="-" :value="taskDetail?.phone"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    taskDetail: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      typeTask: {
        1: "Gia sư đặc biệt",
        2: "Gia sư sau khai giảng",
        3: "Gia sư lớp đệm",
        4: "Gia sư chính sách",
        5: "Gia sư quân sự",
        6: "Gia sư thi lại",
        7: "Gia sư năng lực"
      }
    }
  },
  methods: {
    goStudentDetail() {
      this.$router.push({
        name: 'customer-crm-detail',
        params: {
          id: this.taskDetail.userId,
        },
        query: {
          best_customer_id: this.taskDetail.best_customer_id,
          active_name: 'cskh'
        }
      })
    },

    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      }
      return '-'
    },
  },
}
</script>

<style scoped>

</style>